/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */

import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Lightbox } from 'react-modal-image';
import 'react-fancybox/lib/fancybox.css';
import defaultGallery from '../../assets/img/gallery_default.png';
import { connect } from 'react-redux';

const SelectRcdImage = ({
  galleryData,
  member,
  setShowGalleryModal,
  onSelect,
}) => {
  const [activeAccordion, setActiveAccordion] = useState('');
  const [singleImgModal, setSingleImgModal] = useState(false);
  const [singleImgUrl, setSingleImgUrl] = useState(false);

  return (
    <>
      <Row>
        {galleryData.map((item, index) => (
          <Col
            key={item.id}
            xs={6}
            sm={4}
            lg={2}
            className={`ringer-gallery-main ${
              index === activeAccordion && 'active-img'
            }`}>
            <div className='ringer-gallery'>
              <img
                src={item.imageUrl || defaultGallery}
                onClick={(e) => {
                  // setSingleImgModal(true);
                  // setSingleImgUrl(e.target.src);
                  setActiveAccordion(index);
                }}
                onError={(e) => {
                  e.target.src = defaultGallery;
                }}
              />
              <p>
                <span title={item.galleryName}>
                  {item.galleryName.length > 10
                    ? item.galleryName.substring(0, 12) + '...'
                    : item.galleryName}
                </span>
              </p>
            </div>
          </Col>
        ))}
      </Row>
      <div className='w-100 text-end'>
        <button
          type='button'
          className='btn btn-primary text-end'
          onClick={(e) => {
            e.preventDefault();
            setShowGalleryModal && setShowGalleryModal(false);
            galleryData?.[activeAccordion] &&
              onSelect(galleryData[activeAccordion]);
          }}>
          Ok
        </button>
      </div>
      {singleImgModal && (
        <Lightbox
          small={singleImgUrl || defaultGallery}
          large={singleImgUrl || defaultGallery}
          hideDownload={true}
          hideZoom={true}
          onClose={() => setSingleImgModal(false)}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ authReducer: { userRole } }) => ({});

export default connect(mapStateToProps)(SelectRcdImage);
